<template>
  <div class="container-login">
    <div class="background"></div>
    <div class="form-container">
      <div class="form">
        <div class="icon-container">
          <div class="logo">
            <img src="@/assets/logo2.png" alt="Logo" />
          </div>
        </div>
        <div class="text-container">
          <h1>¡Hola, bienvenido de nuevo!</h1>
          <p>
            Por favor, ingresa tus datos para poder restablecer tu contraseña.
          </p>
        </div>
        <form method="POST" @submit.prevent="changePass()" class="form-fields">
          <div class="input-group">
            <label for="email">Correo electrónico</label>
            <input
              v-model="email"
              type="email"
              id="email"
              placeholder="Ingresa tu correo electrónico"
              required
            />
          </div>
          <button type="submit" class="submit-btn">Enviar</button>
          <div class="divider">
            <div class="line"></div>
            <span>O volver a</span>
          </div>
          <button type="button" @click="toSignIn()" class="google-btn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <g
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
              >
                <path
                  d="M9.5 10.5v2a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v2m4 3.5h-8"
                />
                <path d="m7.5 5l-2 2l2 2" />
              </g>
            </svg>
            Iniciar sesión
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
    };
  },
  methods: {
    async changePass() {
      try {
        await this.$auth.sendPasswordResetEmail(this.email);
        this.$store.dispatch("notify", {
          message:
            "Perfecto. El correo fue enviado, revisa tu bandeja de entrada.",
          type: "is-white",
          position: "top-center",
        });
      } catch (error) {
        console.log(error);
        this.$store.dispatch("notify", {
          message: "El usuario no existe.",
          type: "is-danger",
          position: "top-center",
          duration: 5000,
        });
      }
    },
    toSignIn() {
      this.$emit("switchForget");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/core/Auth/RecoverPassword.vue